<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      
      <c-metric-selector
      :inventoryItemID="item.inventory_item_id" 
      :realValue="item.quantity"
      :prefferedSid="prefferedSid"
      labelMode
      showLabelUnrounded
      ></c-metric-selector>
    
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {
      // 5
    }
  },
  computed: {
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.item.inventory_item_id]
    },
    prefferedSid () {
      var sid = 'si-units-units'
      switch (this.definition.metric) {
        case 0:
          sid = 'si-units-units'
          break
        case 1:
          sid = 'si-vol-l'
          break
        case 2:
          sid = 'si-mass-kg'
          break
        case 3:
          sid = 'si-len-m'
          break
      }
      return sid
    }
  }
}
</script>
